export const formatNumToMoney = (num: number, n = 2) => {
    if (Number.isNaN(num)) {
        const defaultNum = 0;
        return defaultNum.toFixed(n);
    }

    // 保留指定小数位
    const formattedNum = num.toFixed(n);

    // 分离小数部分和整数部分
    const parts = formattedNum.split('.');
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';

    // 使用正则表达式添加千分位分隔符
    const regex = /(\d)(?=(\d{3})+(?!\d))/g;
    const formattedInteger = integerPart.replace(regex, '$1,');

    return formattedInteger + decimalPart;
};

// 导出其他工具函数...
